import { File, Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { getPrivateDocuments } from "../documents/getPrivateDocuments";
import { saveDocument } from "../documents/saveDocument";

function savePlanzoneLogo(
  apiHttpClient: HttpClient,
  docHttpClient: HttpClient,
) {
  return (planzone: Identifiable<Planzone>, logo: File) =>
    getPrivateDocuments(docHttpClient)(planzone.uuid, "planzone")
      .then((rootDocument) =>
        saveDocument(docHttpClient)(
          planzone.uuid,
          "planzone",
          rootDocument,
          logo,
        ),
      )
      .then((document) =>
        apiHttpClient
          .sendHttpRequest<void>({
            endpoint: `/planzones/${planzone.uuid}`,
            method: HttpMethods.PATCH,
            data: {
              data: {
                logo: document.uuid,
              },
            },
          })
          .then(() => document),
      );
}

export { savePlanzoneLogo };
